import React from 'react'
import PropTypes from 'prop-types'
import { Select } from 'ui/styled'
import { dataLoader } from 'utils/helpers'
import useChatSelect from './useChatSelect'

const ChatSelect = ({
  memberId = null,
  value = undefined,
  onChange = () => {},
  ...props
}) => {
  const { functions, data } = useChatSelect({ memberId })
  const { loading, chatOptions } = data
  const { onPopupScroll } = functions

  return (
    <Select
      placeholder="Select Chat"
      loading={loading}
      disabled={!memberId || loading}
      value={value}
      onChange={onChange}
      options={chatOptions}
      popupMatchSelectWidth={false}
      showSearch={false}
      notFoundContent={dataLoader(loading)}
      onPopupScroll={onPopupScroll}
      allowClear
      {...props}
    />
  )
}

ChatSelect.propTypes = {
  memberId: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
}

export default ChatSelect
